import React from 'react';
import AppHeader from '../../components/header/header';
import { connect } from "react-redux";
import { AppState } from '../../store';
import { withRouter } from 'react-router';
import { HashLoader } from "react-spinners";

import 'react-dropdown/style.css';
import { UsersState } from '../../store/users/types';
import { loadUserById, loadUsers, updateUserField, saveUser, emptyUser, selectNoRoles, selectAllRoles, selectAllRolesInGroup, selectNoRolesInGroup, addRole, removeRole, resetPassword } from '../../store/users/actions';
import StickySaveBar from '../../components/stickySaveBar/stickySaveBar';
import { loadRoles, selectGroup } from '../../store/roles/actions';
import { RolesState } from '../../store/roles/types';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { Button } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import { tooltips, missingDependencyRoles } from '../../lib/tooltips';

const spinnerStyle = `
    margin: 100px auto;
`

const userHasRole = (user) => (role): boolean => {
    if (user !== null && user['cognito:groups']) {
        return user['cognito:groups'].find(userRole => userRole.GroupName === role) !== undefined;
    }
    return false
}
const isActiveGroup = (group, userHasRole) => {
    if (group == 'Report all' || !group.startsWith('Report')) {
        return true;
    }
    const org = group.split(' ')[1].toLowerCase();
    return !userHasRole(`rep_all_${org}-admin-access`) && userHasRole(`rep_all_access`);
}

interface UserInterfaceProps {
    users: UsersState
    roles: RolesState
    loadUserById: Function
    loadUsers: Function
    updateUserField: Function
    saveUser: Function
    emptyUser: Function
    loadRoles: Function
    selectGroup: Function
    addRole: Function
    removeRole: Function
    selectAllRoles: Function
    selectNoRoles: Function
    selectAllRolesInGroup: Function
    selectNoRolesInGroup: Function
    resetPassword: Function
    match: {
        params: {
            id: number
        }
    },
    history: any
}

interface UserInterfaceState { value: string, filter: string };

class UserEditInternal extends React.Component<UserInterfaceProps, UserInterfaceState> {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            filter: ''
        };

        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    public componentDidMount(): void {
        this.props.loadRoles();
        if (this.props.match.params.id) {
            this.props.loadUserById(this.props.match.params.id);
        } else {
            this.props.emptyUser();
        }
    }

    private handleFilterChange(event) {
        this.setState({ filter: event.target.value });
    }

    private handleChange(field: string, value: any): void {
        this.props.updateUserField(field, value);
    }

    private handleSubmit(event): void {
        event.preventDefault();
        this.props.saveUser(this.props.users.editedUser, this.props.history);
    }

    // private remove(id: any): void {
    //     if(window.confirm('Are you sure you want to delete the Offer?') )
    //         this.props.removeOffer(id, this.props.history);
    // } 

    private userHasRole(role): boolean {
        return userHasRole(this.props.users.editedUser)(role);
    }

    public getRolesInGroupCount(group): number {
        let count = 0;
        if (this.props.users.editedUser) {
            this.props.users.editedUser['cognito:groups'].forEach(role => {
                if (group.find(group => group.GroupName === role.GroupName)) {
                    count++;
                }
            })
        }
        return count
    }

    private resetPassword(e) {
        e.preventDefault();
        this.props.resetPassword(this.props.users.editedUser?.email);
    }

    public switchRole(group): void {
        let currentUser = this.props.users.editedUser;
        if (currentUser) {
            let found = currentUser['cognito:groups'].find(itm => itm.GroupName === group.GroupName)
            if (found) {
                this.props.removeRole(currentUser.Username, group);
            } else {
                this.props.addRole(currentUser.Username, group);

                // check if the group is for all reports access
                let org = group.GroupName.match(/rep_all_(?<org>[a-z]*)-admin-access/);
                // if it is all reports access
                if(org){
                    org = org.groups.org;
                    // get all previous roles for that company
                    const orgRoles = currentUser['cognito:groups'].filter(r=>r.GroupName.startsWith(`rep_${org}-`));
                    const self = this;
                    orgRoles.forEach((r,i)=>{
                        setTimeout(() => {
                            // remove all previous roles in a sequence of 100ms
                            self.props.removeRole(currentUser?.Username, r);
                        }, i*100); // do only 10 assignments per sec : quota is 15
                    })

                }
            }
        }
    }


    public render(): JSX.Element {

        return (
            <div>
                <AppHeader>
                    <Button onClick={() => document.location.href = '/'} style={{ marginLeft: '10px' }}>
                        <ArrowBack style={{ color: 'var(--color3)' }} />
                    </Button>
                </AppHeader>
                <HashLoader
                    css={spinnerStyle}
                    size={100}
                    color={"#297DAC"}
                    loading={this.props.users.loadingUser} />
                {!this.props.users.loadingUser && this.props.users.editedUser !== null ?

                    <form className="sections__form" onSubmit={this.handleSubmit.bind(this)}>
                        <StickySaveBar />
                        <section style={{
                            padding: '20px 20px 20px'
                        }}>
                            <div className="page__title">
                                <h1 className="section__name" style={{ padding: '0 0 10px 0' }}>Basic Information</h1>
                            </div>

                            <HashLoader
                                css={spinnerStyle}
                                size={100}
                                color={"#297DAC"}
                                loading={this.props.users.loadingUser} />


                            {!this.props.users.loadingUser && this.props.users.editedUser !== null ?
                                <div>
                                    <div className="flexBox">
                                        <div>
                                            <label>Email</label>
                                            <div>
                                                <input required type="text" value={this.props.users.editedUser.email} onChange={event => this.handleChange('email', event.target.value)} />
                                            </div>
                                        </div>

                                        <div>
                                            <label>First Name</label>
                                            <div>
                                                <input required type="text" value={this.props.users.editedUser['custom:firstName']} onChange={event => this.handleChange('custom:firstName', event.target.value)} />
                                            </div>
                                        </div>

                                        <div>
                                            <label>Last Name</label>
                                            <div>
                                                <input required type="text" value={this.props.users.editedUser['custom:lastName']} onChange={event => this.handleChange('custom:lastName', event.target.value)} />
                                            </div>
                                        </div>

                                        <div>
                                            <label>Phone Number</label>
                                            <div>
                                                <input required type="text" value={this.props.users.editedUser.phone_number} onChange={event => this.handleChange('phone_number', event.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div style={{ display: 'flex' }}>
                                        {this.props.users.editedUser.Username && (
                                            <button className="button white" style={{ padding: '0 36px' }} onClick={(e) => this.resetPassword(e)}>Reset Password</button>
                                        )}
                                        <div style={{ display: 'flex', marginLeft: 'auto' }}>
                                            <label>User is Active?</label>
                                            <div className="checkbox">
                                                <input
                                                    onChange={() => null}
                                                    type="checkbox"
                                                    checked={this.props.users.editedUser.Enabled}
                                                />
                                                <span className="checkmark" onClick={() => this.handleChange('Enabled', !this.props.users.editedUser?.Enabled)}></span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                : null}
                        </section>

                        {this.props.users.editedUser.Username && (
                            <section style={{
                                padding: '20px 20px 20px'
                            }}>
                                <div className="page__title">
                                    <h1 className="section__name" style={{ padding: '0 0 10px 0' }}>Roles</h1>
                                    <input style={{marginLeft:10}} type="text" value={this.state.filter} onChange={this.handleFilterChange} placeholder="Quick filter..." />
                                </div>

                                <HashLoader
                                    css={spinnerStyle}
                                    size={100}
                                    color={"#297DAC"}
                                    loading={this.props.users.loadingUser} />
                                {!this.props.users.loadingUser ?

                                    <div className={'roles-manager'}>
                                        <div className={'list'}>
                                            <ul style={{
                                                marginTop: '10px',
                                                maxHeight: '500px',
                                                overflowY: 'auto',
                                                overflowX: 'hidden',
                                                paddingRight: '10px'
                                            }}>
                                                {Object
                                                .keys(this.props.roles.rolesGrouped)
                                                .filter(e=>this.state.filter!=''? e.toLowerCase().includes(this.state.filter.toLowerCase()): true)
                                                .map(key => {
                                                    const isActive = isActiveGroup(key, userHasRole(this.props.users.editedUser))
                                                    return isActive ? <li className={`${this.props.roles.selectedGroupName == key ? 'active' : ''}`} onClick={() => this.props.selectGroup(this.props.roles.rolesGrouped[key], key)} key={`group_${key}`}>
                                                        {key}
                                                        <span style={{ color: '#000', fontSize: '14px', float: 'right' }}>{this.getRolesInGroupCount(this.props.roles.rolesGrouped[key])}/{this.props.roles.rolesGrouped[key].length}</span>
                                                    </li> : null
                                                }
                                                )}
                                            </ul>
                                        </div>

                                        <div className={'details'}>
                                            {this.props.roles.selectedGroup !== null && (
                                                <>
                                                    <h4 style={{ marginTop: 0, textTransform: 'capitalize' }}>
                                                        {this.props.roles.selectedGroupName}
                                            &nbsp;
                                            | Select: &nbsp;
                                            <a onClick={() => this.props.selectAllRolesInGroup(this.props.users.editedUser?.Username, this.props.roles.selectedGroup)}>All</a>&nbsp;/&nbsp;
                                            <a onClick={() => this.props.selectNoRolesInGroup(this.props.users.editedUser?.Username, this.props.roles.selectedGroup)}>None</a>

                                                        <span className="error">{this.props.users.error}</span>
                                                    </h4>
                                                    <ul>
                                                        {this.props.roles.selectedGroup.map(role => {
                                                            const missingRoles = missingDependencyRoles(role.GroupName, this.props.users.editedUser ? this.props.users.editedUser['cognito:groups'].map(r => r.GroupName) : []);
                                                            const disabled = missingRoles.length > 0;
                                                            return <li onClick={() => !disabled ? this.switchRole(role) : null} key={`role_${role.GroupName}`} className={(disabled ? ' disabled' : '')}>
                                                                <label onClick={e => e.preventDefault()} className="checkbox">
                                                                    <input onClick={e => e.preventDefault()} type="checkbox" disabled={disabled} readOnly
                                                                        checked={this.userHasRole(role.GroupName)} />
                                                                    <span className="checkmark"></span>
                                                                </label>

                                                                {tooltips[role.GroupName] ?
                                                                    <Tooltip title={tooltips[role.GroupName] + ' ' + (disabled ? '' : '')} arrow placement="top">
                                                                        <span>
                                                                            {role.prettyName}
                                                                            <InfoOutlinedIcon className="info"></InfoOutlinedIcon>
                                                                        </span>
                                                                    </Tooltip>
                                                                    :
                                                                    role.prettyName}
                                                            </li>
                                                        }
                                                        )}
                                                    </ul>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    : null}
                            </section>
                        )}
                    </form>
                    : null}
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateUserField: (field, value) => dispatch(updateUserField(field, value)),
        loadUsers: history => dispatch(loadUsers(history)),
        loadUserById: id => dispatch(loadUserById(id)),
        saveUser: (user, history) => dispatch(saveUser(user, history)),
        emptyUser: () => dispatch(emptyUser()),
        loadRoles: () => dispatch(loadRoles()),
        selectGroup: (group, name) => dispatch(selectGroup(group, name)),
        addRole: (username, role) => dispatch(addRole(username, role)),
        removeRole: (username, role) => dispatch(removeRole(username, role)),
        selectAllRoles: roles => dispatch(selectAllRoles(roles)),
        selectNoRoles: roles => dispatch(selectNoRoles(roles)),
        selectAllRolesInGroup: (username, roles) => dispatch(selectAllRolesInGroup(username, roles)),
        selectNoRolesInGroup: (username, roles) => dispatch(selectNoRolesInGroup(username, roles)),
        resetPassword: email => dispatch(resetPassword(email))
    }
}

const mapStateToProps = (state: AppState) => ({
    users: state.users,
    roles: state.roles
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(UserEditInternal)
);
